import React, {Fragment, useState, useEffect} from 'react';
import * as S from './AisProfileLeftSection.styles';
import AisProfileListItem from './AisProfileListItem/AisProfileListItem';
import {IProfileLeftSection, IDataElement, IComponent} from '../../../../shared/types/aisProfile';

const AisProfileLeftSection: React.FC<IProfileLeftSection> = (props): React.ReactElement => {
  const {order, navBar} = props;
  const [activeArray, setActiveArray] = useState([]);

  useEffect(() => {
    const {data} = navBar || {};
    const newActivestateArr = [];

    for (let i = 0; i < data?.items?.length; i++) {
      newActivestateArr.push(data?.items[i]);
    }

    setActiveArray(newActivestateArr);
  }, [navBar]);

  const handleActiveStateSwitch = keyClicked => {
    const newActivestateArr = activeArray;
    for (let i = 0; i < activeArray?.length; i++) {
      if (activeArray[i].keyToRefer === keyClicked) {
        activeArray[i].isActive = true;
      } else {
        activeArray[i].isActive = false;
      }
    }
    setActiveArray([...newActivestateArr]);
  };

  const renderComponent: React.FC = (element: Partial<IComponent>): React.ReactElement => {
    const {component, data} = element;

    switch (component) {
      case 'IMAGE':
        return <div className="aisProfielPic">{<img src={data?.url} />}</div>;
      case 'NAV_BAR':
        return (
          <ul className="appendTop16">
            {data?.items &&
              data?.items.map((item, idx) => {
                return (
                  <AisProfileListItem
                    handleOnClick={handleActiveStateSwitch}
                    {...item}
                    isActive={activeArray[idx]?.isActive}
                  />
                );
              })}
          </ul>
        );
      default:
        return (
          <p className="font20 lineHeight24 latoBlack appendTop16">
            <span className={``}>{data?.primaryText}</span>
          </p>
        );
    }
  };

  return (
    <S.ProfileMainWrap>
      <div className="aisProfileWrap">
        {order?.length > 0 &&
          order?.map((item, idx) => {
            return <Fragment key={idx}>{renderComponent(props[item])}</Fragment>;
          })}
        {/* 
         CAN BE REQUIRED LATER
        <div className="aisProfielPic">
          <span className="perfectCenter latoBlack font32 lineHeight40 capText">sp</span>
        </div> */}
        {/* <p className="font20 lineHeight24 latoBlack appendTop16">Suppliers Profile</p> */}
      </div>
    </S.ProfileMainWrap>
  );
};

export default AisProfileLeftSection;
